import { EnumDto, EshopOrderStateService } from '@/api';

export default {
  getEshopOrderStates: async (): Promise<EnumDto[]> => {
    const response = await EshopOrderStateService.eshopOrderStateControllerGetAll();
    return response.data;
  },
};
